import { BodyText } from '@paypalcorp/pp-react'
import { merge } from 'lodash-es'
import PageMessage from 'ppbl/components/PageMessage'
import { useApplicationContext } from 'ppbl/hooks'
import clientLogger from 'ppbl/utils/client-logger'
import { redirectToServerRoute } from 'ppbl/utils/common-utils'
import { CaseTypes } from 'ppbl/utils/constants'
import { trackClick, trackPage } from 'ppbl/utils/fpti-helper'
import { FPTI_EVENTS } from 'ppbl/utils/fptiEventNames'
import { getLocalizedText } from 'ppbl/utils/locale-helper'
import React, { useEffect } from 'react'
import { getPortalUrl, getRenewalStatus } from '../__utils__'

const fptiData = {
  page: 'ineligibleStatePage',
  event_name: FPTI_EVENTS.PAGE.INELIGIBLE_STATE,
}

type Props = {
  applicationType: string
}

const IneligibleStatePage: React.FC<Props> = ({ applicationType }) => {
  const { data } = useApplicationContext()

  useEffect(() => {
    clientLogger.info(
      'IneligibleState page is loaded - Application ID:',
      data?.applicationMetaData?.applicationId,
    )
    trackPage(
      merge(fptiData, {
        applicationId: data?.applicationMetaData?.applicationId,
      }),
    )
  }, [])

  const handleOnClick = () => {
    trackClick(
      merge(fptiData, {
        component: 'restartApplication_button',
        link: 'restartApplication_button',
        applicationId: data?.applicationMetaData?.applicationId,
      }),
    )
    redirectToServerRoute(
      `/merchant-lending/loanbuilder/${applicationType}/start`,
    )
  }

  return (
    <PageMessage
      type="error"
      onPrimaryAction={handleOnClick}
      localization={{
        title: getLocalizedText('ineligibleState-page.title'),
        primaryText: getLocalizedText('ineligibleState-page.backButton'),
      }}
    >
      <BodyText className="body__text">
        {getLocalizedText('ineligibleState-page.bodyText')}
      </BodyText>
    </PageMessage>
  )
}

export default IneligibleStatePage
